import {
  IClientPatch,
  IPatchAddAction,
  IPatchDeleteAction,
  IPatchInsertAction,
  IPatchSubstAction,
  PatchType,
} from "../../../components/course-author/helpers/patches";
import { createPatchBase } from "../../../components/course-author/helpers/patches/creators";
import { IClass, IClassGoalResponse } from "../../types/common";

export function modifyClassTitlePatch(
  someClass: IClass,
  userId: string,
  title: string
): IClientPatch<IPatchSubstAction<string>> {
  return {
    ...createPatchBase(userId, someClass.versionId + 1),
    patch: {
      action: {
        type: PatchType.subst,
        x: someClass.displayName,
        y: title,
      },
      position: "displayName",
    },
  };
}

export function addNewManager(
  someClass: IClass,
  currentAccount: string,
  memberId: string
): IClientPatch<IPatchInsertAction<string>> {
  return {
    ...createPatchBase(currentAccount, someClass.versionId + 1),
    patch: {
      action: {
        elem: memberId,
        type: PatchType.ins,
      },
      position: "admins",
    },
  };
}

export function removeManager(
  someClass: IClass,
  currentAccount: string,
  memberId: string
): IClientPatch<IPatchDeleteAction<string>> {
  return {
    ...createPatchBase(currentAccount, someClass.versionId + 1),
    patch: {
      action: {
        elem: memberId,
        type: PatchType.del,
      },
      position: "admins",
    },
  };
}
export function addNewMember(
  someClass: IClass,
  currentAccount: string,
  memberId: string
): IClientPatch<IPatchInsertAction<string>> {
  return {
    ...createPatchBase(currentAccount, someClass.versionId + 1),
    patch: {
      action: {
        elem: memberId,
        type: PatchType.ins,
      },
      position: "members",
    },
  };
}

export function removeMember(
  someClass: IClass,
  currentAccount: string,
  memberId: string
): IClientPatch<IPatchDeleteAction<string>> {
  return {
    ...createPatchBase(currentAccount, someClass.versionId + 1),
    patch: {
      action: {
        elem: memberId,
        type: PatchType.del,
      },
      position: "members",
    },
  };
}

export function addNewGoal(
  someClass: IClass,
  userId: string,
  courseId: string
): IClientPatch<IPatchAddAction<IClassGoalResponse>> {
  const at: number = someClass.goals.nextId;
  return {
    ...createPatchBase(userId, someClass.versionId + 1),
    patch: {
      action: {
        at,
        item: {
          course: courseId,
          courseInstEnv: {
            allowCourseReview: true,
            assumePriorKnowledge: true,
            includeBranding: true,
            useStrictMode: false,
          },
          deleted: false,
          description: "",
          displayName: "",
          id: at,
        },
        type: PatchType.add,
      },
      position: "goals",
    },
  };
}

export function deleteGoal(
  someClass: IClass,
  userId: string,
  coursePosId: number
): IClientPatch<IPatchSubstAction<boolean>> {
  return {
    ...createPatchBase(userId, someClass.versionId + 1),
    patch: {
      action: {
        type: PatchType.subst,
        x: false,
        y: true,
      },
      position: `goals.${coursePosId}.deleted`,
    },
  };
}
